var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NotFound',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Page not found")]),_c('div',{attrs:{"slot":"p"},slot:"p"},[_vm._v("The requested page has not been found.")])])}
var staticRenderFns = []

export { render, staticRenderFns }